__turbopack_context__.v({
  "box": "Formulier-module-scss-module__FtO3cG__box",
  "boxForm": "Formulier-module-scss-module__FtO3cG__boxForm",
  "boxFormInner": "Formulier-module-scss-module__FtO3cG__boxFormInner",
  "boxInputs": "Formulier-module-scss-module__FtO3cG__boxInputs",
  "btnbox": "Formulier-module-scss-module__FtO3cG__btnbox",
  "mkgeu_titel": "Formulier-module-scss-module__FtO3cG__mkgeu_titel",
  "open": "Formulier-module-scss-module__FtO3cG__open",
  "outroImages": "Formulier-module-scss-module__FtO3cG__outroImages",
  "pt-5": "Formulier-module-scss-module__FtO3cG__pt-5",
  "rowInputs": "Formulier-module-scss-module__FtO3cG__rowInputs",
  "toelichting": "Formulier-module-scss-module__FtO3cG__toelichting",
  "toelichtingBox": "Formulier-module-scss-module__FtO3cG__toelichtingBox",
  "toelichtingLabel": "Formulier-module-scss-module__FtO3cG__toelichtingLabel",
  "trust_logos": "Formulier-module-scss-module__FtO3cG__trust_logos",
});
